var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(" Installaties "), _c("w-spacer")], 1),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "filters" },
                        [
                          _c("w-switch", {
                            attrs: {
                              space: "",
                              label: "Enkel gemaakt in Winfakt Online",
                              value: _vm.onlyCreatedByWfOnline,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onOnlyCreatedByWfOnlineToggle($event)
                              },
                            },
                          }),
                          _c("w-switch", {
                            attrs: {
                              space: "",
                              label: "Alle tonen",
                              value: _vm.showAll,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setShowAll($event)
                              },
                            },
                          }),
                          _c("w-switch", {
                            attrs: {
                              space: "",
                              label: "Starters tonen",
                              value: _vm.showStarters,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setShowStarters($event)
                              },
                            },
                          }),
                          _c("w-switch", {
                            attrs: {
                              space: "",
                              label: "Profs tonen",
                              value: _vm.showProfs,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setShowProfs($event)
                              },
                            },
                          }),
                          _c("w-switch", {
                            attrs: {
                              space: "",
                              label: "Enterprises tonen",
                              value: _vm.showEnterprises,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setShowEnterprises($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c("w-spacer"),
                      _c("w-date-picker", {
                        attrs: {
                          value: _vm.beginDate,
                          max: _vm.endDate,
                          label: "Begindatum",
                          fancy: "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setBeginDate($event)
                          },
                        },
                      }),
                      _c("w-date-picker", {
                        staticClass: "ml",
                        attrs: {
                          value: _vm.endDate,
                          min: _vm.startDate,
                          max: _vm.now,
                          label: "Einddatum",
                          fancy: "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setEndDate($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("h4", [_vm._v("Nieuwe installaties")]),
                  _c("apexchart", {
                    ref: "chartNew",
                    attrs: {
                      height: 300,
                      options: _vm.chartOptions,
                      series: _vm.initialSeries,
                      type: "area",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("h4", [_vm._v("Totaal installaties")]),
                  _c("apexchart", {
                    ref: "chartTotal",
                    attrs: {
                      height: 300,
                      options: _vm.chartOptions,
                      series: _vm.initialSeries,
                      type: "area",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("h4", [_vm._v("Totaal aantal nieuwe installaties")]),
                  _c("apexchart", {
                    ref: "chartDiff",
                    attrs: {
                      height: 300,
                      options: _vm.chartOptions,
                      series: _vm.initialSeries,
                      type: "area",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }